import { render, staticRenderFns } from "./WordHighlight.vue?vue&type=template&id=94061e44&"
import script from "./WordHighlight.vue?vue&type=script&lang=ts&"
export * from "./WordHighlight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports